import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import {
  FaComments, FaCalendarAlt, FaStore, FaShieldAlt, FaCheck, FaClipboardList, FaTags
} from 'react-icons/fa';

const Homepage = () => {
  return (
    <div className="bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="bg-gradient-to-b from-indigo-600 to-violet-600 text-white pt-20 pb-16">
        <div className="max-w-7xl mx-auto px-6 flex flex-col lg:flex-row items-center justify-between gap-10">
          {/* Left Content */}
          <div className="text-center lg:text-left space-y-6 max-w-xl">
            <h1 className="text-4xl sm:text-5xl font-extrabold leading-tight">
              Your Neighborhood,<br />Digitally Connected
            </h1>
            <p className="text-lg text-white/90">
              Community chat. Amenity bookings.<br />Local services. in one secure place.
            </p>
            <div className="flex gap-4 justify-center lg:justify-start">
              <button className="bg-white text-indigo-700 font-semibold px-5 py-3 rounded-md shadow hover:bg-gray-100">Explore Demo</button>
              <a href="https://app.communityportal.ai/get-started" className="border border-white text-white px-5 py-3 rounded-md hover:bg-white hover:text-indigo-700">Get the App</a>
            </div>
          </div>

          {/* Right Image */}
          <div className="w-[280px] sm:w-[320px]">
            <img src="/iphone-dashboard-mock.png" alt="Dashboard" className="rounded-xl shadow-xl" />
          </div>
        </div>
      </section>

      {/* Disconnected Neighbors */}
      <section className="py-16 px-6 text-center">
        <h2 className="text-xl font-semibold text-gray-900 mb-2">Disconnected neighbors?</h2>
        <p className="text-gray-600 mb-8">One app to unify and simplify.</p>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-8 max-w-5xl mx-auto">
          <Feature icon={<FaComments size={32} />} label="Community Chat" />
          <Feature icon={<FaCalendarAlt size={32} />} label="Amenity Bookings" />
          <Feature icon={<FaStore size={32} />} label="Local Marketplace" />
          <Feature icon={<FaShieldAlt size={32} />} label="Security Updates" />
        </div>

        <div className="mt-6">
          <a href="https://app.communityportal.ai/get-started" className="text-indigo-600 font-medium hover:underline">Join events</a>
        </div>
      </section>

      {/* Features */}
      <section className="bg-gray-50 py-14 px-6 text-center">
        <h2 className="text-xl font-semibold text-gray-900 mb-6">Features</h2>
        <div className="flex flex-wrap justify-center gap-6 text-sm font-medium text-gray-800">
          <Tag icon={<FaCheck />} text="Chat with neighbors" />
          <Tag icon={<FaClipboardList />} text="Book amenities" />
          <Tag icon={<FaTags />} text="Buy & sell locally" />
        </div>
      </section>

      {/* How It Works */}
      <section className="bg-white py-16 px-6 text-center">
        <h2 className="text-xl font-semibold text-gray-900 mb-6">How It Works</h2>
        <div className="flex flex-col sm:flex-row justify-center gap-10 text-sm font-medium text-gray-800">
          <div>1. Sign up & verify</div>
          <div>2. Connect with neighbors</div>
          <div>3. Access everything</div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="bg-gray-50 py-16 px-6 text-center">
        <h2 className="text-xl font-semibold text-gray-900 mb-10">Resident testimonials</h2>
        <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto">
          <Testimonial name="Sarah Thompson" title="Verified Resident" quote="Brings our community together" />
          <Testimonial name="Lisa Patel" title="Neighbor" quote="The app makes it easy to book amenities" />
          <Testimonial name="Mark Davis" title="Policeaccounty" quote="It’s great for finding out about local services" />
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default Homepage;

// Reusable Components
const Feature = ({ icon, label }) => (
  <div className="flex flex-col items-center">
    <div className="text-indigo-600 mb-2">{icon}</div>
    <p className="text-sm font-medium text-gray-800">{label}</p>
  </div>
);

const Tag = ({ icon, text }) => (
  <div className="flex items-center gap-2 bg-white border shadow px-4 py-2 rounded-md">
    <span className="text-indigo-600">{icon}</span>
    <span>{text}</span>
  </div>
);

const Testimonial = ({ name, title, quote }) => (
  <div className="bg-white p-6 rounded-lg shadow text-left">
    <div className="mb-2 text-lg font-semibold text-gray-800">{name}</div>
    <div className="text-sm text-gray-500 mb-3">{title}</div>
    <p className="text-sm italic text-gray-700">“{quote}”</p>
  </div>
);
